import moment from 'moment';
import _ from 'lodash';
import format from 'format-number';
import stripHtml from '../libs/sanitization/stripHtml';

/**
 * Return number as pretty formatted currency
 * @param number
 * @returns {string | *}
 */
export const formatAsCurrency = (number) => format({ prefix: '$', padRight: 2 })(number, {});

/**
 * Format a date string in a standard way
 * @param date
 * @returns {*}
 */
export const dateFormat = (date) => {
  if (!date) {
    return '';
  }
  return moment(date).format('Do MMM YYYY, HH:mm');
};

export const dateFormatRelative = (date) => {
  if (!date) {
    return '';
  }
  return moment(date).calendar(moment(), {
    // sameDay: '[Today]',
    // nextDay: '[Tomorrow]',
    // nextWeek: 'dddd',
    // lastDay: '[Yesterday]',
    // lastWeek: '[Last] dddd',
    // sameElse: 'Do MMM YYYY'
  });
};

export const dateFormatNoTime = (date) => moment(date).format('Do MMM YYYY');
export const dateFormatSimple = (date) => moment(date).format('DD/MM/YYYY');

export const dateFormatWithTime = (date) => moment(date).format('Do MMM YYYY, HH:mm:ss');

export const dateFormatWithDayNameFull = (date) => {
  if (!_.isString(date)) {
    return '';
  }
  return moment(date).format('dddd Do MMM YYYY');
};

export const dateFormatWithDayNameShort = (date) => {
  if (!_.isString(date)) {
    return '';
  }
  return moment(date).format('ddd Do MMM YYYY');
};

export const showFullName = (user) => [user.firstName, user.middleName, user.lastName].join(' ');

export const yesNo = (value) => (value ? 'Yes' : 'No');

export const removeHtml = (str) => stripHtml(str);
